import { Fragment } from "react";
import { shape, string, array } from "prop-types";
import QuickSearchBar from "../../QuickSearchBar/QuickSearchBar.jsx";
import ReportBuilderIcon from "../ReportBuilderIcon/ReportBuilderIcon.jsx";

const propTypes = {
  search: shape({
    endpoint: string,
    placeholder: string,
  }).isRequired,
  dataExplorer: shape({
    href: string.isRequired,
    label: string.isRequired,
  }),
  draftReport: array,
};

const AuxiliaryNav = (props) => {
  const { search, dataExplorer, draftReport } = props;

  return (
    <Fragment>
      {dataExplorer && (
        <a href={dataExplorer.href} className="data-explorer">
          {dataExplorer.label}
        </a>
      )}

      {/* <a href="#search" className="global-header__search">
      <span className="visually-hidden">Search</span>
      <svg className="global-header__search-icon" role="presentation">
        <use xlinkHref="/Areas/EGH/assets/svg-sprite.svg#search"></use>
      </svg>
    </a> */}

      {/* <div
        className="js-quick-search-bar-mount"
        data-endpoint={searchEndpoint}
      ></div> */}
      <QuickSearchBar {...search} />
      <ReportBuilderIcon draftReport={draftReport} />
    </Fragment>
  );
};

AuxiliaryNav.propTypes = propTypes;
export default AuxiliaryNav;
